import styled from '@emotion/styled';

import CaptionLoad from './components/Caption/CaptionLoad';
import DownloadButton from './components/DownloadButton/DownloadButton';
import HowToPayHeader from './components/HowToPayHeader';
import HowToPayList from './components/HowToPayList';
import QrImage from './components/QrImage';
import { QRRepayment } from 'src/types/generated/pos';

const Container = styled.div`
	padding: 0 16px;
	position: relative;
`;

type QrRepaymentLoadProps = {
	qrData: QRRepayment;
	providerCode: string;
};

const QrRepaymentLoad = (props: QrRepaymentLoadProps) => {
	const { qrData, providerCode } = props;

	return (
		<Container>
			<QrImage src={qrData.qrUrl} />
			<CaptionLoad />
			<HowToPayHeader />
			<HowToPayList providerCode={providerCode} />
			<DownloadButton isLoading />
		</Container>
	);
};

export default QrRepaymentLoad;
